export default function PortalSmoke() {
  return (
    <div style={{padding:16,fontFamily:"sans-serif"}}>
      <h1>Broker Portal — Smoke Test</h1>
      <p>If you can see this, routing + React render are OK.</p>
    </div>
  );
}
